// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%206a.5.5%200%200%200%200%201V6zM12.854.646a.5.5%200%200%200-.708.708l.708-.708zM18%206.5l.354.354a.5.5%200%200%200%200-.708L18%206.5zm-5.854%205.146a.5.5%200%200%200%20.708.708l-.708-.708zM1%207h16.5V6H1v1zm16.646-.854l-5.5%205.5.708.708%205.5-5.5-.708-.708zm-5.5-4.792l2.75%202.75.708-.708-2.75-2.75-.708.708zm2.75%202.75l2.75%202.75.708-.708-2.75-2.75-.708.708z%22%20fill%3D%22%231264A3%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/bgcouple.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "../node_modules/@trussworks/react-uswds/lib/index.css"; */

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.left-1\\/2 {
  left: 50%;
}
.top-1\\/2 {
  top: 50%;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-9 {
  grid-column: span 9 / span 9;
}
.col-start-1 {
  grid-column-start: 1;
}
.col-start-2 {
  grid-column-start: 2;
}
.m-auto {
  margin: auto;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-24 {
  margin-bottom: 6rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-6 {
  height: 1.5rem;
}
.h-96 {
  height: 24rem;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-3\\/4 {
  width: 75%;
}
.w-72 {
  width: 18rem;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.max-w-5xl {
  max-width: 64rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.table-fixed {
  table-layout: fixed;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-opacity-25 {
  --tw-border-opacity: 0.25;
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.leading-normal {
  line-height: 1.5;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

html {
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
  font-family: 'Open Sans', Calibri, Georgia, Tahoma, "Segoe UI",'Montserrat' !important;
}

body {
  font-family: 'Open Sans', Calibri, Georgia, Tahoma, "Segoe UI",'Montserrat' !important;
  
}

@media screen and (min-width: 640px) {
  html {
    font-size: 14px;
    font-family: 'Open Sans', Calibri, Georgia, Tahoma, "Segoe UI",'Montserrat' !important;
  }
}

@media screen and (min-width: 768px) {
  html {
    font-size: 15px;
  }
}

.rich-text-hero a {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
  text-decoration-line: underline;
}

.rich-text-banner {
  white-space: pre-line;
  a {
    text-decoration-line: underline;
  }
}

.title {
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 600;
  line-height: 1.375;
}

@media (min-width: 768px) {
  .title {
    font-size: 3rem;
    line-height: 1;
  }
}

.with-arrow:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  content: "";
  width: 19px;
  height: 13px;
  display: inline-block;
  margin-left: 0.5em;
}

.smillingman-img {
  background-image: url("https://unsplash.com/photos/N_VKV2XZ50s");
}

.couple-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  color: #fff;
}

.scustom-img {
  background-image: url("https://images.unsplash.com/photo-1454496522488-7a8e488e8606?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1955&q=80");
}

p {
  /*font-family: 'source-sans-pro, helvetica, arial, sans-serif, Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;*/
  font-family: 'Open Sans', Calibri, Georgia, Tahoma, "Segoe UI",'Montserrat' !important;

  font-weight: 400;
  line-height: 1.5;
}

.cta--blue {
  background-color: #080f29;
}
.cta-blue-light {
  background-color: #075391;
}
.cta-card {
  background-color: #6634a4;
}
.minimg {
  min-width: 10px;
  max-width: 100px;
}

.nonetext {
  color: #080f29;
}

/* Tab content - closed */
.tab-content {
  max-height: 0;
  transition: max-height 0.35s;
}
/* :checked - resize to full height */
.tab input:checked ~ .tab-content {
  max-height: 100vh;
}
/* Label formatting when open */
.tab input:checked + label {
  /*@apply text-xl p-5 border-l-2 border-indigo-500 bg-gray-100 text-indigo*/
  /*font-size: 1.875rem; .text-xl*/
  padding: 1.25rem; /*.p-5*/
  border-left-width: 0px; /*.border-l-2*/
  border-color: #6574cd; /*.border-indigo*/
  background-color: #f8fafc; /*.bg-gray-100 */
  color: black; /*.text-indigo*/
}
/* Icon */
.tab label::after {
  float: right;
  right: 0;
  top: 0;
  display: block;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  font-size: 1.5rem;
  text-align: center;
  transition: all 0.35s;
  color: #4c00b0
}
/* Icon formatting - closed */
.tab input[type="checkbox"] + label::after {
  content: "+";
  font-weight: bold; /*.font-bold*/
  border-width: 0px; /*.border*/
  border-radius: 9999px; /*.rounded-full */
  border-color: #b8c2cc; /*.border-grey*/
}
.tab input[type="radio"] + label::after {
  content: "-";
  font-weight: bold; /*.font-bold*/
  border-width: 0px; /*.border*/
  border-radius: 9999px; /*.rounded-full */
  border-color: #b8c2cc; /*.border-grey*/
}
/* Icon formatting - open */
.tab input[type="checkbox"]:checked + label::after {
  content: "-";
  /*transform: rotate(315deg);
  background-color: #6574cd; /*.bg-indigo*/
  /*color: #f8fafc; /*.text-grey-lightest*/
  color: #4c00b0
}
.tab input[type="radio"]:checked + label::after {
  transform: rotateX(180deg);
  background-color: #6574cd; /*.bg-indigo*/
  color: #f8fafc; /*.text-grey-lightest*/
}

.css-1w1pnf0-UL {
  max-height: 500px !important;
}

body,
p {
  font-family: 'Open Sans', Calibri, Georgia, Tahoma, "Segoe UI",'Montserrat' !important;
  font-size: 1.25rem;
}
div#pgnone div.css-x2306x-pagination {
  display: none;
}

.card-list ul > li::before {
  background-color: rgba(76, 29, 149) !important;
}
.card-list ul {
  list-style-type: disc;
  margin-bottom:10px;


}

.card-list ul>li::marker {
color:#4c1d95
}

.mega-menu {
  display: none;
  left: 0;
  position: absolute;
  text-align: left;
  width: 100%;
  z-index:10;
 
}
/* @media only screen and (min-width: 960px) {
  .mega-menu {
    z-index:-10
  }
} */

/* #hoverable Class Styles
–––––––––––––––––––––––––––––––––––––––––––––––––– */

.hoverable:after {
  content: "\\25BC";
  font-size: 10px;
  padding-left: 6px;
  position: relative;
  top: -1px;
}

.hoverable:hover .mega-menu {
  display: block;
}



.hoverable:focus .mega-menu {
  display: block;
}

/* #toggle Class Styles
–––––––––––––––––––––––––––––––––––––––––––––––––– */

.toggleable > label:after {
  content: "\\25BC";
  font-size: 10px;
  padding-left: 6px;
  position: relative;
  top: -1px;
}

.toggle-input {
  display: none;
}
.toggle-input:not(checked) ~ .mega-menu {
  display: none;
}

.toggle-input:checked ~ .mega-menu {
  display: block;
}

.toggle-input:checked ~ label:after {
  content: "\\25B2";
  font-size: 10px;
  padding-left: 6px;
  position: relative;
  top: -1px;
}

div.alink a {
  color: rgba(37, 99, 235, 1);
  text-decoration: none;
}

div.alink a:hover {
  text-decoration: underline;
}

ul.a {
  list-style-type: circle;
}

ol,
ul {
  padding: revert;
}

a:hover {
  text-decoration: underline;
  padding-top: 1px;
}

.prose a {
  color: rgba(37, 99, 235, 1);
  text-decoration: none;
}

.prose a:hover {
  color: rgba(37, 99, 235, 1);
  text-decoration: underline;
}

#safeBtn {
  position: fixed;
  bottom: 0;
  right: 30%;
  z-index: 99;
  border: none;
  outline: none;
  background-color: #eb0000 !important;
  color: #fff;
  cursor: pointer;
  padding: 5px 0px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.gsc-control-cse {
  background-color: transparent !important;
  border: 0px solid #0071bb !important;
  padding: 0px !important
}

.gsc-search-button-v2 {
  padding: 8px 10px !important;
}

.gsc-search-button-v2 svg {
  fill: #1e0455 !important;
}

.gsc-search-button-v2,
.gsc-search-button-v2:hover,
.gsc-search-button-v2:focus {
  border-color: white !important;
  background-color: white !important;
  background-image: none;
  filter: none;
}

.gsc-input-box {
  border-radius: 5px;
}

div.richtext >div> ul {
  list-style: disc;
}

div.richtext>div> p>span {
  margin-bottom: 10px;
}
div.richtext>div > h2>span {
  font-size: 2.5rem;
  padding-bottom:20px;
}

div.richtext >div> h3 >span{
  font-size: 2rem;
  padding-bottom:20px;
  font-weight: 600;
}

div.richtext>div > h2 {
 
  padding-bottom:20px;
}

div.richtext >div> h3{
  
  padding-bottom:20px;
  
}

button.btnclose > svg {
  color: black !important;
}

div.rich-text-banner > p {
  display: inline;
}
/* 
div.recaptcha >div >div {
  width:100% !important
}

div.recaptcha >div >div>div>iframe {
  width:100% !important
} */
.card-height {
  height: 300px;
}

@media only screen and (max-width: 1400px) {
  .card-height {
    height: 430px;
  }
}

@media only screen and (max-width: 1200px) {
  .card-height {
    height: 500px;
  }
}

@media only screen and (max-width: 1050px) {
  .card-height {
    height: 500px;
  }
}
@media only screen and (max-width: 960px) {
  .card-height {
    height: 700px;
  }
}


@media only screen and (max-width: 1050px){
.card-height {
    height: 430px;
}}

@media only screen and (max-width: 640px) {
  .card-height {
    height: auto;
  }
}

@media only screen and (max-width: 1600px) {
  .recaptcha {
    transform: scale(0.7);
    -webkit-transform: scale(0.7);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}

@media only screen and (max-width: 1200px) {
  .recaptcha {
    transform: scale(0.6);
    -webkit-transform: scale(0.6);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}

@media only screen and (max-width: 960px) {
  .recaptcha {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}

@media only screen and (max-width: 770px) {
  .recaptcha {
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}



.usa-banner__lock-image {display:inline-block!important}

nav  li:hover, nav li:focus-within {
  cursor: pointer;
}

.btnclose svg {
  display:inline !important;
}
.acllogo{
width:57px  !important;
padding-bottom:3px
}
.hhslogo{
  width:27px  !important;

padding-bottom:3px

}


.hoverable:after {
  content: "\\25BC";
  font-size: 10px;
  padding-left: 6px;
  position: relative;
  top: -1px;
}
.hoverable:hover:after {
  content: "\\25B2";
  font-size: 10px;
  padding-left: 6px;
  position: relative;
  top: -1px;
}
.navbar-menu li:focus-within > div  /* IE11+ only */ {
  display: block;
  visibility: visible;
  opacity: 1;
  transition-delay: 0s;
}

/************************* Form **********************/
.visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  }

  /****************************/

  .dropdown:hover .dropdown-menu {
    display: block;
    z-index:10
  }

  @media only screen and (min-width: 960px) {
    .dropdown .dropdown-menu  {
      z-index:-10
    }
  }
  
  .dropdown:after {
    content: "\\25BC";
    font-size: 10px;
    padding-left: 2px;
    position: relative;
    top: -1px;
  }


  

  div.markdownlist>h2{
    font-size:24px;
    font-weight:600
  }

 
  div.markdownlist>p>strong{
    font-size:14px;
    font-weight: 400 !important
    
  }

  div.header-col>h1>span{
    
    font-weight: 800 !important;
    font-size:larger
    
  }

 


  div.header-col>h2>span{
    
    font-weight: 800 !important;
    
    
  }


  div.card-list>h4>span{

    font-weight:600;
    font-size:24px;
  }

  div.accordion>p{
    padding-top:20px;
    padding-bottom:20px
  }

  @media only screen and (max-width: 960px) {
    .titleh1   {
      font-size: 32px !important

}
.content_smallwindow h1 span,
.content_smallwindow h2 span,
.content_smallwindow h3 span,
.content_smallwindow p span {
  font-size: 24px !important
}
    

    .cardcontent h1 span,
.cardcontent h2 span,
.cardcontent h3 span,
.cardcontent p span {
  font-size: 18px !important
}
    }

   
.pagination {
      display: flex;
      padding-left: 0;
      list-style: none;
      position:relative;
      left:50%;
      margin-left:-100px
  }

  .page-item:first-child .page-link {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}

.page-link {
  padding: 0.375rem 0.75rem;
  position: relative;
  display: block;
  color: #0d6efd;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

h2{
  font-size:36px;
  font-weight: 600;
  padding-bottom:5px;
  overflow-wrap: break-word;
}

h3{
  font-size:30px;
  font-weight: 600;
  padding-bottom:5px;
  overflow-wrap: break-word;
}
h1{
  font-size:60px;
  font-weight: 600;
  padding-bottom:5px;
  overflow-wrap: break-word;
}
h4{
  font-weight: 600;
  font-size: 1.0em;
  margin-top: 1.0em;
  margin-bottom: 0.6em;
  line-height: 1.6;
  overflow-wrap: break-word;
}

 
 @media only screen and (max-width: 960px) {
   .boxshadow{
     box-shadow: none
    }
   }

  a.cardLink {
    text-decoration: none !important;
  }

  .containerLink {
  
    cursor: pointer;
    position: relative;
  }
  .link {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }

  @media only screen and (max-width: 640px) {
  .bannerbg {
    background-image: none !important;
  } 
  .bannerbgColor {
    background-color: transparent !important;
  }
}

.table {
  margin-left: auto;
    margin-right: auto;
}
.table table {
  margin-left: auto;
    margin-right: auto;
}
.image {
  margin-left: auto;
    margin-right: auto;
}

@media only screen and (max-width: 768px) {
.mobile{
padding-left:20px !important;
padding-right:20px !important;
}
}

@media only screen and (min-width: 768px)  {.shadow
{box-Shadow:5px 0 5px 0px rgba(0,0,0,0.75)}}

h4>a{
  color: #2563eb;
  text-decoration: none;
  }

  .gsc-control-cse
  {
    color:black
  }

  .gsc-input {
    font-size: 18px !important;
}

.css-hlgwow {
  font-size:16px;
}

.mt-1 {
  font-size:16px;
}

.form-group >label{
  font-weight:700;
}

.formtab{
  background-color: #06528F;
  border-radius: 0px 0px;

 
}
.form-label{
  color: #06528F;
  font-weight: 500;
}
.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-500:hover {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
@media (min-width: 640px) {

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:pl-0 {
    padding-left: 0px;
  }
}
@media (min-width: 768px) {

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .md\\:ml-auto {
    margin-left: auto;
  }

  .md\\:h-14 {
    height: 3.5rem;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-4\\/5 {
    width: 80%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
@media (min-width: 1024px) {

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .lg\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
}
@media (min-width: 1280px) {

  .xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd,kEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,eAAe;EACf,oBAAoB;EAApB,gDAAoB;EACpB,sFAAsF;AACxF;;AAEA;EACE,sFAAsF;;AAExF;;AAEA;EACE;IACE,eAAe;IACf,sFAAsF;EACxF;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAGE;EAAA,oBAA8B;EAA9B,iDAA8B;EAA9B;AAA8B;;AAI9B;EAAA,qBAA0B;EAExB;IAAA;EAAgB;AAFQ;;AAO1B;EAAA,kBAA0C;EAA1C,mBAA0C;EAA1C,gBAA0C;EAA1C;AAA0C;;AAG5C;EAEI;IAAA,eAAe;IAAf;EAAe;AAEnB;;AAEA;EACE,yDAAujB;EACvjB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,yDAAoD;EACpD,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,yLAAyL;AAC3L;;AAEA;EACE,0HAA0H;EAC1H,sFAAsF;;EAEtF,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EAIf,gBAAgB;AAHlB;;AAMA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EAGb,4BAA4B;AAC9B;AACA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;AACA,+BAA+B;AAC/B;EACE,0EAA0E;EAC1E,gCAAgC;EAChC,gBAAgB,EAAE,OAAO;EACzB,sBAAsB,EAAE,cAAc;EACtC,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY,EAAE,eAAe;AAC/B;AACA,SAAS;AACT;EACE,YAAY;EACZ,QAAQ;EACR,MAAM;EACN,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAGlB,qBAAqB;EACrB;AACF;AACA,6BAA6B;AAC7B;EACE,YAAY;EACZ,iBAAiB,EAAE,aAAa;EAChC,iBAAiB,EAAE,UAAU;EAC7B,qBAAqB,EAAE,iBAAiB;EACxC,qBAAqB,EAAE,eAAe;AACxC;AACA;EACE,YAAY;EACZ,iBAAiB,EAAE,aAAa;EAChC,iBAAiB,EAAE,UAAU;EAC7B,qBAAqB,EAAE,iBAAiB;EACxC,qBAAqB,EAAE,eAAe;AACxC;AACA,2BAA2B;AAC3B;EACE,YAAY;EACZ;0CACwC;EACxC,wCAAwC;EACxC;AACF;AACA;EACE,0BAA0B;EAC1B,yBAAyB,EAAE,aAAa;EACxC,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,sFAAsF;EACtF,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,kBAAkB;;;AAGpB;;AAEA;AACA;AACA;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;;AAEZ;AACA;;;;GAIG;;AAEH;oDACoD;;AAEpD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;oDACoD;;AAEpD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EAEX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;;AAErB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;AACA;;;;;;;GAOG;AACH;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;;AAGA;AACA;IACI,aAAa;AACjB,CAAC;;AAED;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;;;AAIA,yBAAyB,8BAA8B;;AAEvD;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;AACA,sBAAsB;AACtB;AACA;AACA;EACE,sBAAsB;;AAExB;;AAEA;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV;;EAEA,6BAA6B;;EAE7B;IACE,cAAc;IACd;EACF;;EAEA;IACE;MACE;IACF;EACF;;EAEA;IAQE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EANX;;;;;EAYA;IACE,cAAc;IACd;EACF;;;EAGA;IACE,cAAc;IACd;;EAEF;;EAEA;;IAEE,2BAA2B;IAC3B;;EAEF;;;;;EAKA;;IAEE,2BAA2B;;;EAG7B;;;EAGA;;IAEE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB;EACF;;EAEA;IACE;MACE;;AAEN;AACA;;;;EAIE;AACF;;;IAGI;;;;EAIF;AACF;IACI;;;AAGJ;MACM,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,QAAQ;MACR;EACJ;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EAIzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,8HAA8H;AAThI;;AAYA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;;CAGC;GACE;KACE;IACD;GACD;;EAED;IACE,gCAAgC;EAClC;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,UAAU;EACZ;;EAEA;EACA;IACE,iCAAiC;EACnC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,iBAAiB;IACf,kBAAkB;AACtB;AACA;EACE,iBAAiB;IACf,kBAAkB;AACtB;AACA;EACE,iBAAiB;IACf,kBAAkB;AACtB;;AAEA;AACA;AACA,4BAA4B;AAC5B,6BAA6B;AAC7B;AACA;;AAEA,4CAA4C;CAC3C,yCAAyC,CAAC;;AAE3C;EACE,cAAc;EACd,qBAAqB;EACrB;;EAEA;;IAEE;EACF;;EAEA;IACE,0BAA0B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;;;AAGxB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AAnwBA;EAAA,kBAowBA;EApwBA;AAowBA;AApwBA;EAAA,kBAowBA;EApwBA;AAowBA;AApwBA;EAAA,kBAowBA;EApwBA;AAowBA;AApwBA;EAAA,kBAowBA;EApwBA;AAowBA;AApwBA;EAAA,oBAowBA;EApwBA;AAowBA;AApwBA;EAAA,oBAowBA;EApwBA;AAowBA;AApwBA;EAAA,sBAowBA;EApwBA;AAowBA;AApwBA;EAAA,kBAowBA;EApwBA;AAowBA;AApwBA;EAAA,8BAowBA;EApwBA;AAowBA;AApwBA;EAAA,2GAowBA;EApwBA,yGAowBA;EApwBA;AAowBA;AApwBA;EAAA,oBAowBA;EApwBA;AAowBA;AApwBA;EAAA;AAowBA;AApwBA;;EAAA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA,iBAowBA;IApwBA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA,oBAowBA;IApwBA;EAowBA;;EApwBA;IAAA,oBAowBA;IApwBA;EAowBA;;EApwBA;IAAA;EAowBA;AAAA;AApwBA;;EAAA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA,iBAowBA;IApwBA;EAowBA;;EApwBA;IAAA,kBAowBA;IApwBA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA,kBAowBA;IApwBA;EAowBA;;EApwBA;IAAA,oBAowBA;IApwBA;EAowBA;AAAA;AApwBA;;EAAA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA,iBAowBA;IApwBA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;;EApwBA;IAAA,kBAowBA;IApwBA;EAowBA;AAAA;AApwBA;;EAAA;IAAA;EAowBA;;EApwBA;IAAA;EAowBA;AAAA","sourcesContent":["/* @import \"../node_modules/@trussworks/react-uswds/lib/index.css\"; */\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml {\n  font-size: 13px;\n  @apply text-gray-900;\n  font-family: 'Open Sans', Calibri, Georgia, Tahoma, \"Segoe UI\",'Montserrat' !important;\n}\n\nbody {\n  font-family: 'Open Sans', Calibri, Georgia, Tahoma, \"Segoe UI\",'Montserrat' !important;\n  \n}\n\n@media screen and (min-width: 640px) {\n  html {\n    font-size: 14px;\n    font-family: 'Open Sans', Calibri, Georgia, Tahoma, \"Segoe UI\",'Montserrat' !important;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  html {\n    font-size: 15px;\n  }\n}\n\n.rich-text-hero a {\n  @apply text-blue-600 underline;\n}\n\n.rich-text-banner {\n  @apply whitespace-pre-line;\n  a {\n    @apply underline;\n  }\n}\n\n.title {\n  @apply text-4xl leading-snug font-semibold;\n}\n\n@media (min-width: 768px) {\n  .title {\n    @apply text-5xl;\n  }\n}\n\n.with-arrow:after {\n  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%206a.5.5%200%200%200%200%201V6zM12.854.646a.5.5%200%200%200-.708.708l.708-.708zM18%206.5l.354.354a.5.5%200%200%200%200-.708L18%206.5zm-5.854%205.146a.5.5%200%200%200%20.708.708l-.708-.708zM1%207h16.5V6H1v1zm16.646-.854l-5.5%205.5.708.708%205.5-5.5-.708-.708zm-5.5-4.792l2.75%202.75.708-.708-2.75-2.75-.708.708zm2.75%202.75l2.75%202.75.708-.708-2.75-2.75-.708.708z%22%20fill%3D%22%231264A3%22%2F%3E%3C%2Fsvg%3E);\n  content: \"\";\n  width: 19px;\n  height: 13px;\n  display: inline-block;\n  margin-left: 0.5em;\n}\n\n.smillingman-img {\n  background-image: url(\"https://unsplash.com/photos/N_VKV2XZ50s\");\n}\n\n.couple-img {\n  background-image: url(\"/public/images/bgcouple.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-attachment: fixed;\n  color: #fff;\n}\n\n.scustom-img {\n  background-image: url(\"https://images.unsplash.com/photo-1454496522488-7a8e488e8606?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1955&q=80\");\n}\n\np {\n  /*font-family: 'source-sans-pro, helvetica, arial, sans-serif, Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;*/\n  font-family: 'Open Sans', Calibri, Georgia, Tahoma, \"Segoe UI\",'Montserrat' !important;\n\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.cta--blue {\n  background-color: #080f29;\n}\n.cta-blue-light {\n  background-color: #075391;\n}\n.cta-card {\n  background-color: #6634a4;\n}\n.minimg {\n  min-width: 10px;\n}\n\n.minimg {\n  max-width: 100px;\n}\n\n.nonetext {\n  color: #080f29;\n}\n\n/* Tab content - closed */\n.tab-content {\n  max-height: 0;\n  -webkit-transition: max-height 0.35s;\n  -o-transition: max-height 0.35s;\n  transition: max-height 0.35s;\n}\n/* :checked - resize to full height */\n.tab input:checked ~ .tab-content {\n  max-height: 100vh;\n}\n/* Label formatting when open */\n.tab input:checked + label {\n  /*@apply text-xl p-5 border-l-2 border-indigo-500 bg-gray-100 text-indigo*/\n  /*font-size: 1.875rem; .text-xl*/\n  padding: 1.25rem; /*.p-5*/\n  border-left-width: 0px; /*.border-l-2*/\n  border-color: #6574cd; /*.border-indigo*/\n  background-color: #f8fafc; /*.bg-gray-100 */\n  color: black; /*.text-indigo*/\n}\n/* Icon */\n.tab label::after {\n  float: right;\n  right: 0;\n  top: 0;\n  display: block;\n  width: 1.5em;\n  height: 1.5em;\n  line-height: 1.5;\n  font-size: 1.5rem;\n  text-align: center;\n  -webkit-transition: all 0.35s;\n  -o-transition: all 0.35s;\n  transition: all 0.35s;\n  color: #4c00b0\n}\n/* Icon formatting - closed */\n.tab input[type=\"checkbox\"] + label::after {\n  content: \"+\";\n  font-weight: bold; /*.font-bold*/\n  border-width: 0px; /*.border*/\n  border-radius: 9999px; /*.rounded-full */\n  border-color: #b8c2cc; /*.border-grey*/\n}\n.tab input[type=\"radio\"] + label::after {\n  content: \"-\";\n  font-weight: bold; /*.font-bold*/\n  border-width: 0px; /*.border*/\n  border-radius: 9999px; /*.rounded-full */\n  border-color: #b8c2cc; /*.border-grey*/\n}\n/* Icon formatting - open */\n.tab input[type=\"checkbox\"]:checked + label::after {\n  content: \"-\";\n  /*transform: rotate(315deg);\n  background-color: #6574cd; /*.bg-indigo*/\n  /*color: #f8fafc; /*.text-grey-lightest*/\n  color: #4c00b0\n}\n.tab input[type=\"radio\"]:checked + label::after {\n  transform: rotateX(180deg);\n  background-color: #6574cd; /*.bg-indigo*/\n  color: #f8fafc; /*.text-grey-lightest*/\n}\n\n.css-1w1pnf0-UL {\n  max-height: 500px !important;\n}\n\nbody,\np {\n  font-family: 'Open Sans', Calibri, Georgia, Tahoma, \"Segoe UI\",'Montserrat' !important;\n  font-size: 1.25rem;\n}\ndiv#pgnone div.css-x2306x-pagination {\n  display: none;\n}\n\n.card-list ul > li::before {\n  background-color: rgba(76, 29, 149) !important;\n}\n.card-list ul {\n  list-style-type: disc;\n  margin-bottom:10px;\n\n\n}\n\n.card-list ul>li::marker {\ncolor:#4c1d95\n}\n\n.mega-menu {\n  display: none;\n  left: 0;\n  position: absolute;\n  text-align: left;\n  width: 100%;\n  z-index:10;\n \n}\n/* @media only screen and (min-width: 960px) {\n  .mega-menu {\n    z-index:-10\n  }\n} */\n\n/* #hoverable Class Styles\n–––––––––––––––––––––––––––––––––––––––––––––––––– */\n\n.hoverable:after {\n  content: \"\\25BC\";\n  font-size: 10px;\n  padding-left: 6px;\n  position: relative;\n  top: -1px;\n}\n\n.hoverable:hover .mega-menu {\n  display: block;\n}\n\n\n\n.hoverable:focus .mega-menu {\n  display: block;\n}\n\n/* #toggle Class Styles\n–––––––––––––––––––––––––––––––––––––––––––––––––– */\n\n.toggleable > label:after {\n  content: \"\\25BC\";\n  font-size: 10px;\n  padding-left: 6px;\n  position: relative;\n  top: -1px;\n}\n\n.toggle-input {\n  display: none;\n}\n.toggle-input:not(checked) ~ .mega-menu {\n  display: none;\n}\n\n.toggle-input:checked ~ .mega-menu {\n  display: block;\n}\n\n.toggle-input:checked ~ label:after {\n  content: \"\\25B2\";\n  font-size: 10px;\n  padding-left: 6px;\n  position: relative;\n  top: -1px;\n}\n\ndiv.alink a {\n  color: rgba(37, 99, 235, 1);\n  text-decoration: none;\n}\n\ndiv.alink a:hover {\n  text-decoration: underline;\n}\n\nul.a {\n  list-style-type: circle;\n}\n\nol,\nul {\n  padding: revert;\n}\n\na:hover {\n  text-decoration: underline;\n  padding-top: 1px;\n}\n\n.prose a {\n  color: rgba(37, 99, 235, 1);\n  text-decoration: none;\n}\n\n.prose a:hover {\n  color: rgba(37, 99, 235, 1);\n  text-decoration: underline;\n}\n\n#safeBtn {\n  position: fixed;\n  bottom: 0;\n  right: 30%;\n  z-index: 99;\n  font-size: 14px;\n  border: none;\n  outline: none;\n  background-color: #eb0000 !important;\n  color: #fff;\n  cursor: pointer;\n  padding: 5px 0px;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.gsc-control-cse {\n  background-color: transparent !important;\n  border: 0px solid #0071bb !important;\n  padding: 0px !important\n}\n\n.gsc-search-button-v2 {\n  padding: 8px 10px !important;\n}\n\n.gsc-search-button-v2 svg {\n  fill: #1e0455 !important;\n}\n\n.gsc-search-button-v2,\n.gsc-search-button-v2:hover,\n.gsc-search-button-v2:focus {\n  border-color: white !important;\n  background-color: white !important;\n  background-image: none;\n  filter: none;\n}\n\n.gsc-input-box {\n  border-radius: 5px;\n}\n\ndiv.richtext >div> ul {\n  list-style: disc;\n}\n\ndiv.richtext>div> p>span {\n  margin-bottom: 10px;\n}\ndiv.richtext>div > h2>span {\n  font-size: 2.5rem;\n  padding-bottom:20px;\n}\n\ndiv.richtext >div> h3 >span{\n  font-size: 2rem;\n  padding-bottom:20px;\n  font-weight: 600;\n}\n\ndiv.richtext>div > h2 {\n \n  padding-bottom:20px;\n}\n\ndiv.richtext >div> h3{\n  \n  padding-bottom:20px;\n  \n}\n\nbutton.btnclose > svg {\n  color: black !important;\n}\n\ndiv.rich-text-banner > p {\n  display: inline;\n}\n/* \ndiv.recaptcha >div >div {\n  width:100% !important\n}\n\ndiv.recaptcha >div >div>div>iframe {\n  width:100% !important\n} */\n.card-height {\n  height: 300px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .card-height {\n    height: 430px;\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .card-height {\n    height: 500px;\n  }\n}\n\n@media only screen and (max-width: 1050px) {\n  .card-height {\n    height: 500px;\n  }\n}\n@media only screen and (max-width: 960px) {\n  .card-height {\n    height: 700px;\n  }\n}\n\n\n@media only screen and (max-width: 1050px){\n.card-height {\n    height: 430px;\n}}\n\n@media only screen and (max-width: 640px) {\n  .card-height {\n    height: auto;\n  }\n}\n\n@media only screen and (max-width: 1600px) {\n  .recaptcha {\n    transform: scale(0.7);\n    -webkit-transform: scale(0.7);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .recaptcha {\n    transform: scale(0.6);\n    -webkit-transform: scale(0.6);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media only screen and (max-width: 960px) {\n  .recaptcha {\n    transform: scale(0.5);\n    -webkit-transform: scale(0.5);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media only screen and (max-width: 770px) {\n  .recaptcha {\n    transform: scale(0.8);\n    -webkit-transform: scale(0.8);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n\n\n.usa-banner__lock-image {display:inline-block!important}\n\nnav  li:hover, nav li:focus-within {\n  cursor: pointer;\n}\n\n.btnclose svg {\n  display:inline !important;\n}\n.acllogo{\nwidth:57px  !important;\npadding-bottom:3px\n}\n.hhslogo{\n  width:27px  !important;\n\npadding-bottom:3px\n\n}\n\n\n.hoverable:after {\n  content: \"\\25BC\";\n  font-size: 10px;\n  padding-left: 6px;\n  position: relative;\n  top: -1px;\n}\n.hoverable:hover:after {\n  content: \"\\25B2\";\n  font-size: 10px;\n  padding-left: 6px;\n  position: relative;\n  top: -1px;\n}\n.navbar-menu li:focus-within > div  /* IE11+ only */ {\n  display: block;\n  visibility: visible;\n  opacity: 1;\n  transition-delay: 0s;\n}\n\n/************************* Form **********************/\n.visuallyhidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  }\n\n  /****************************/\n\n  .dropdown:hover .dropdown-menu {\n    display: block;\n    z-index:10\n  }\n\n  @media only screen and (min-width: 960px) {\n    .dropdown .dropdown-menu  {\n      z-index:-10\n    }\n  }\n  \n  .dropdown:after {\n    content: \"\\25BC\";\n    font-size: 10px;\n    padding-left: 2px;\n    position: relative;\n    top: -1px;\n  }\n  .dropdown:after {\n    content: \"\\25BC\";\n    font-size: 10px;\n    padding-left: 2px;\n    position: relative;\n    top: -1px;\n  }\n\n\n  \n\n  div.markdownlist>h2{\n    font-size:24px;\n    font-weight:600\n  }\n\n \n  div.markdownlist>p>strong{\n    font-size:14px;\n    font-weight: 400 !important\n    \n  }\n\n  div.header-col>h1>span{\n    \n    font-weight: 800 !important;\n    font-size:larger\n    \n  }\n\n \n\n\n  div.header-col>h2>span{\n    \n    font-weight: 800 !important;\n    \n    \n  }\n\n\n  div.card-list>h4>span{\n\n    font-weight:600;\n    font-size:24px;\n  }\n\n  div.accordion>p{\n    padding-top:20px;\n    padding-bottom:20px\n  }\n\n  @media only screen and (max-width: 960px) {\n    .titleh1   {\n      font-size: 32px !important\n\n}\n.content_smallwindow h1 span,\n.content_smallwindow h2 span,\n.content_smallwindow h3 span,\n.content_smallwindow p span {\n  font-size: 24px !important\n}\n    \n\n    .cardcontent h1 span,\n.cardcontent h2 span,\n.cardcontent h3 span,\n.cardcontent p span {\n  font-size: 18px !important\n}\n    }\n\n   \n.pagination {\n      display: flex;\n      padding-left: 0;\n      list-style: none;\n      position:relative;\n      left:50%;\n      margin-left:-100px\n  }\n\n  .page-item:first-child .page-link {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n\n.page-link {\n  padding: 0.375rem 0.75rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: #0d6efd;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\nh2{\n  font-size:36px;\n  font-weight: 600;\n  padding-bottom:5px;\n  overflow-wrap: break-word;\n}\n\nh3{\n  font-size:30px;\n  font-weight: 600;\n  padding-bottom:5px;\n  overflow-wrap: break-word;\n}\nh1{\n  font-size:60px;\n  font-weight: 600;\n  padding-bottom:5px;\n  overflow-wrap: break-word;\n}\nh4{\n  font-weight: 600;\n  font-size: 1.0em;\n  margin-top: 1.0em;\n  margin-bottom: 0.6em;\n  line-height: 1.6;\n  overflow-wrap: break-word;\n}\n\n \n @media only screen and (max-width: 960px) {\n   .boxshadow{\n     box-shadow: none\n    }\n   }\n\n  a.cardLink {\n    text-decoration: none !important;\n  }\n\n  .containerLink {\n  \n    cursor: pointer;\n    position: relative;\n  }\n  .link {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n\n  @media only screen and (max-width: 640px) {\n  .bannerbg {\n    background-image: none !important;\n  } \n  .bannerbgColor {\n    background-color: transparent !important;\n  }\n}\n\n.table {\n  margin-left: auto;\n    margin-right: auto;\n}\n.table table {\n  margin-left: auto;\n    margin-right: auto;\n}\n.image {\n  margin-left: auto;\n    margin-right: auto;\n}\n\n@media only screen and (max-width: 768px) {\n.mobile{\npadding-left:20px !important;\npadding-right:20px !important;\n}\n}\n\n@media only screen and (min-width: 768px)  {.shadow\n{box-Shadow:5px 0 5px 0px rgba(0,0,0,0.75)}}\n\nh4>a{\n  color: #2563eb;\n  text-decoration: none;\n  }\n\n  .gsc-control-cse\n  {\n    color:black\n  }\n\n  .gsc-input {\n    font-size: 18px !important;\n}\n\n.css-hlgwow {\n  font-size:16px;\n}\n\n.mt-1 {\n  font-size:16px;\n}\n\n.form-group >label{\n  font-weight:700;\n}\n\n.formtab{\n  background-color: #06528F;\n  border-radius: 0px 0px;\n\n \n}\n.form-label{\n  color: #06528F;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
